import { Link } from '@tanstack/react-router';
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
} from '@web/components/ui/card';
import { Button } from '@web/components/ui/button';

export default function ContactNotFound({ id }: { id: string }) {
  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle className="text-red-700">404 - Contact Not Found</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-4">
          The contact with id {id} was not found. Perhaps the URL was mistyped?
        </p>
        <div className="space-x-4">
          <Button asChild>
            <Link to="/">Home</Link>
          </Button>
          <Button asChild>
            <Link to="/dashboard/admin/contact/list">Contact List</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
